import gettext from '@sdk/lang/gettext';
import { useSession } from '@sdk/session/SessionContext';

import TitleIcon from '@web/assets/svg/Icons/32/messages-blue.svg';
import TextEditorModal from '@web/richText/TextEditorModal/TextEditorModal';
import { useConversationPersonas } from '@web/conversations/Conversation/ConversationProvider/hooks/useConversationPersonas/useConversationPersonas';
import {
  Wrapper,
  WrapperInner,
  CloseButton,
  CloseIcon,
} from '@web/richText/TextEditorModal/textEditorModal.styles';
import { MessagePreview } from '@web/conversations/Message/MessagePreview/MessagePreview';
import { TextEditorErrorBoundary } from '@web/conversations/Conversation/ConversationTextEditor/TextEditorErrorBoundary';

import { useMessageEditModal } from './messageEditModal.hooks';

const MessageEditModal = () => {
  const { currentUser } = useSession();
  const mentionPersonas = useConversationPersonas();
  const { isVisible, editedMessage, onClose, onSubmit } = useMessageEditModal();

  if (!editedMessage) {
    return null;
  }

  return (
    <TextEditorErrorBoundary>
      <TextEditorModal
        initialValue={editedMessage.content}
        initialAttachments={editedMessage.attachments}
        currentUser={currentUser}
        personas={mentionPersonas}
        isOpen={isVisible}
        onClose={onClose}
        onSubmit={onSubmit}
        titleText={gettext('Edit message')}
        titleIcon={<TitleIcon />}
        preContent={
          !!editedMessage.parentMessage && (
            <Wrapper>
              <WrapperInner>
                <MessagePreview message={editedMessage.parentMessage} />
              </WrapperInner>
            </Wrapper>
          )
        }
      />
    </TextEditorErrorBoundary>
  );
};

export default MessageEditModal;
